<template>
  <div class="">
    <div v-if="!this.initialLoading">
      <div class="container-bg-white">
        <div class="row p-3" id="filterGroup">
          <div class="col-12 col-xl-3 mb-2 mb-xl-0">
            <img src="@/assets/images/filter.svg"/>
            <span class="ml-3">{{$t("flexben.general.filter")}}</span>
          </div>
          <div class="col-12 col-xl-9">
            <div class="row table-striped">

              <div class="col-12 col-md-4 form-group-multiselect mb-0">
                <label for="select_company" class="col-form-label">{{ $t("flexben.invoice.table.filters.client")
                  }}</label>
                <select class="form-control" v-model="params.company" id="select_type" @change='loadList()'>
                  <option :value="null">-</option>
                  <option v-for="company in filterOptions.companies" :key="company.id" :value="company.id">
                    {{company.name}}
                  </option>
                </select>
              </div>

              <div class="col-12 col-md-4 mb-0">
                <label for="status" class="col-form-label">{{ $t("flexben.invoice.table.filters.invoice_status") }}</label>
                <select class="form-control" v-model="params.status" id="status" @change='loadList()'>
                  <option :value="null"> - </option>
                  <option v-for="status in filterOptions.status" :key="status" :value="status">
                    {{$t("flexben.invoice.table.status_list." + status)}}
                  </option>
                </select>
              </div>

              <div class="col-12 col-md-4 mb-0">
                <label for="type" class="col-form-label">{{ $t("flexben.invoice.table.type") }}</label>
                <select class="form-control" v-model="params.type" id="type" @change='loadList()'>
                  <option :value="null"> - </option>
                  <option v-for="type in filterOptions.types" :key="type" :value="type">
                    {{$t("flexben.invoice.table.types." + type)}}
                  </option>
                </select>
              </div>
              <hr>
              <div class="col-12 col-md-4 mb-0">
                <label for="asfdfdas" class="col-form-label">
                  {{ $t("flexben.invoice.table.filters.invoice_name")}}
                </label>
                <input type="text"
                       name="asfdfdas"
                       autocomplete="off"
                       :placeholder="$t('flexben.general.search')"
                       v-model="params.invoice"
                       v-on:keyup.enter="search()"
                       class="formedituser asfdfdas search-input float-right"/>
              </div>


            </div>
            <div class="row mt-4">
              <div class="col-12 col-md-12 mb-0">
                <button class="btn btn-themed px-4 float-right"
                        @click="loadCreateInvoice()">
                  {{$t("flexben.invoice.invoice_create.buttons.create")}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="container-bg-white mt-3 p-3">
        <div class="row">
          <div class="col-12 col-md-6">
            <h2 class="pl-0 mt-0">{{ $t("flexben.invoice.title") }}</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table-responsive hover-table">
              <table class="table table-striped">
                <thead>
                <tr>
                  <td>{{ $t("flexben.invoice.table.id_mb") }}</td>
                  <td>{{ $t("flexben.invoice.table.id_bou") }}</td>
                  <td>{{ $t("flexben.invoice.table.client_id") }}</td>
                  <td>{{ $t("flexben.invoice.table.client_name") }}</td>
                  <td>{{ $t("flexben.invoice.table.period") }}</td>
                  <td>{{ $t("flexben.invoice.table.created_at") }}</td>
                  <td>{{ $t("flexben.invoice.table.total") }}</td>
                  <td>{{ $t("flexben.invoice.table.status") }}</td>
                  <td>{{ $t("flexben.invoice.table.type") }}</td>
                  <td></td>
                </tr>
                </thead>
                <tbody>
                <template v-if="list.data.length>0">
                  <tr v-for="(item) of list.data" :key="item.id"
                      class="trhover parent">
                    <td>{{ item.id }}</td>
                    <td>{{ item.external_id? item.external_id : '-' }}</td>
                    <td>{{ item.company.identifier }}</td>
                    <td>{{ item.company.name }}</td>
                    <td class="text-bold">{{item.start_date + ' - ' + item.end_date }}</td>
                    <td class="text-bold">{{item.created_at ? moment(item.created_at, 'DD.MM.YYYY') : 'N/A' }}</td>
                    <td> {{item.total}} </td>
                    <td>{{ $t("flexben.invoice.table.status_list." + item.status)}}</td>
                    <td>{{ $t("flexben.invoice.table.types." + item.type)}}</td>
                    <td>
                      <button class="btn action-button" @click="loadDetails(item)">
                        {{$t("flexben.general.btn.see_more")}}
                      </button>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr class="trhover gri-cell">
                    <td colspan="100" class="text-center">{{ $t("flexben.general.no_results_found") }}
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>

          <div class="col-12 p-0">
            <listPagination
              :activePage="list.current_page"
              :currentPage="list.current_page"
              :totalItems="list.total"
              :startItem="list.from"
              :endItem="list.to"
              :itemsPerPage="list.perPage"
              @pageChanged="pageChanged"
              @changePerPage="changePerPage"></listPagination>
          </div>
        </div>
      </div>

    </div>
    <content-loader :loader-visible="loading" :loader-error="loaderError"></content-loader>
    <items
      ref="invoice-details" @loadIndex="loadList(true)"> </items>

    <create-invoice :companies="filterOptions.companies" ref="invoice-create" @loadIndex="loadList()"></create-invoice>
  </div>
</template>

<script>
import httpFlexbenService from "@/http/http-flexben.js";
import InvoiceDetails from "@/components/flexben/invoices/non_core/InvoiceDetails";
import InvoiceCreate from "@/components/flexben/invoices/non_core/CreateInvoice";

export default {
  name: "InvoiceIndex",
  components: {
    'items': InvoiceDetails,
    'create-invoice' : InvoiceCreate
  },
  data() {
    return {
      httpService: httpFlexbenService.invoices,
      initialLoading: true,
      loading: true,
      loaderError: false,
      invoice: null,
      showDetails: false,
      params: {
        page: 1,
        perPage: 20,
        company: null,
        status: null,
        invoice: null,
        type: null
      },
      filterOptions: {
        page: 1,
        perPage: 20,
        companies: [],
        status: [],
        invoice: null,
        types: []
      },

      list: {
        data: [],
        current_page: 1,
        to: 1,
        perPage: 1,
        lastPage: 1,
        total: 1
      }
    }
  },
  created() {
    let permissions = this.flxUserLevel();
    if (permissions.hasAccess && permissions.userLevel === 'admin') {
      this.loadList();
    } else {
      window.location.href = '/company';
    }
  },
  methods: {
    loadList(withDefaultParams) {
      this.loading = true;

      if (withDefaultParams) {
         this.resetParams();
      }
      this.httpService.list(this.params)
        .then((response) => {
          return response.data;
        })
        .then((data) => {
          let items = data.data;
          let filters = data.filters;

          this.list = {
            data: items.data,
            current_page: items.current_page,
            to: items.to,
            perPage: items.perPage,
            lastPage: items.lastPage,
            total: items.total
          };

          this.filterOptions.companies = filters.companies;
          this.filterOptions.status = filters.status;
          this.filterOptions.types = filters.types;

          this.loading = false;
          this.initialLoading = false;
        })
        .catch((error) => {
          this.list = {
            data: [],
            current_page: 1,
            to: 1,
            perPage: 1,
            lastPage: 1,
            total: 1
          };
          if (error.response.status >= 500 && error.response.status < 600) {
            this.loading = false;
            this.loaderError = true;
            this.initialLoading = false;
          }
        });
    },
    loadDetails(item) {
      this.invoice = item;
      this.openModalDetails();
    },
    changePerPage(perPage) {
      this.params.page = 1;
      this.params.perPage = perPage;
      this.loadList();
    },
    pageChanged(page) {
      this.params.page = page;
      this.loadList();
    },
    openModalDetails() {
      this.loading = true;
      this.$refs['invoice-details'].show(this.invoice);
      this.loading = false;
    },
    openModalCreate() {
      this.loading = true;
      this.$refs['invoice-create'].show();
      this.loading = false;
    },
    closeModalDetails() {
      this.showDetails = false;
      this.$refs['invoice-details'].closeModal();
      this.invoice = null;
    },
    search() {
      if (this.params.invoice && this.params.invoice.length >= 3) {
        this.loadList();
      } else if (this.params.invoice === '') {
        this.params.invoice = null;
        this.loadList();
      }
    },
    loadCreateInvoice() {
      this.openModalCreate();
    },
    _toggleLoading(loading, loaderError = false) {
      this.loading = loading;
      this.loaderError = loaderError;
    },
    resetParams()
    {
      this.params = this.$options.data.call(this).params;
    }
  },
};
</script>
